import nb from "./lang.nb.json";
import en from "./lang.en.json";
import de from "./lang.de.json";

export default {
  en,
  nb,
  de
};
